<!-- @TODO Artem: Styles like on mockup -->
@if (render()) {
  <div [pMotion]="computedVisible()"
       [pMotionAppear]="true"
       [pMotionName]="'p-anchored-overlay'"
       [pMotionOptions]="computedMotionOptions()"
       (pMotionOnBeforeEnter)="onBeforeEnter($event)"
       (pMotionOnAfterLeave)="onAfterLeave()"
       [ngClass]="'p-confirm-popup p-component bg-white'"
       [ngStyle]="style"
       [class]="styleClass"
       role="alertdialog"
       (click)="onOverlayClick($event)">
    <div #content class="p-confirm-popup-content">
      <span class="p-confirm-popup-message" [innerHTML]="$safeNavigationMigration(confirmation?.message)"></span>
    </div>
    <div class="p-confirm-popup-footer align-h-space-between">
      @if (confirmation?.rejectVisible !== false) {
        <button
          type="button"
          class="btn basic w-100"
          (click)="onReject()">
          {{ rejectButtonLabel }}
        </button>
      }
      @if (confirmation?.acceptVisible !== false) {
        <button
          type="button"
          class="btn primary w-100"
          (click)="onAccept()">
          {{ acceptButtonLabel }}
        </button>
      }
    </div>
  </div>
}
